// Lib
import loadable from 'react-loadable';

const LoadableOnboardingIntroMobile = loadable({
    loader: () => import(/* webpackChunkName: "onboarding-intro-mobile" */ './OnboardingIntroMobile'),
    loading: () => null,
});

export default LoadableOnboardingIntroMobile;
